import { render, staticRenderFns } from "./ComponentTopo.vue?vue&type=template&id=a604b3e6&scoped=true&"
import script from "./ComponentTopo.vue?vue&type=script&lang=js&"
export * from "./ComponentTopo.vue?vue&type=script&lang=js&"
import style0 from "./ComponentTopo.vue?vue&type=style&index=0&id=a604b3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a604b3e6",
  null
  
)

export default component.exports